/* eslint-disable linebreak-style */
import Swal from "sweetalert2";
import { usuariosService } from "../../_services/usuarios.services";
import { userConstants } from "./constants";
// import { dashboardConstants } from "../Sections/constants";

export const login = (data) => async (dispatch) => {
  dispatch(request());

  try {
    if (data) {
      let result = await usuariosService.login(data);

      if (result?.status === 200) {
        sessionStorage.setItem("sn-gestion-legal", JSON.stringify(result.data));

        dispatch(success(result.data));

        return true;
      }
      else {
        dispatch(failure());
        return Swal.fire("Error!", result.data || "No existe en nuestros registros como usuario externo.", "error");
      }
    } else {
      dispatch(failure());
    }
  } catch (error) {
    console.log(error);
    sessionStorage.removeItem("sn-gestion-legal");
    dispatch(failure(error));
    return;
  }

  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
};